import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { useQuery } from '@apollo/react-hooks';
import { GET_INTROS } from './queries';
import { IIntroductions } from '../../../helper/Types';


import IntroComponent from './IntroComponent';
import IntrosComponent from './IntrosCompoent';

function IntroductionContainer() {
    const history = useHistory();

    const [more, setMore] = useState(false);
    const [limit, setLimit] = useState(5);
    const loadData = useQuery<IIntroductions>(GET_INTROS, {
        variables: {
            offsetDate: undefined,
            limit: limit
        },
        fetchPolicy: "cache-first"
    });

    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const loadedData:any = loadData.data?.intros;
            setMore(loadedData.count > loadedData.posts.length);
        }
    }, [loadData]);

    return(
        <article className="layout-contents-container">

            <IntroComponent />

            { !loadData.error &&
                (
                    <IntrosComponent items={loadData.data?.intros.posts || []} more={more} onLoadMore={(offsetDate) => {
                        const { data, fetchMore } = loadData;
                        fetchMore({
                            variables: {
                                offsetDate: offsetDate,
                                limit: limit
                            },
                            updateQuery: (prev:any, { fetchMoreResult } ) => {
                                if (!fetchMoreResult) return prev;

                                const posts = [...prev.intros.posts, ...fetchMoreResult.intros.posts];
                                setMore(fetchMoreResult.intros.count < posts.length)
                                
                                return Object.assign({} , prev, {
                                    intros: {
                                        ...prev.intros,
                                        posts: posts,
                                    }
                                });
                            }
                        })
                    }} />
                )
            }

        </article>
    );
}

export default IntroductionContainer;
